__turbopack_context__.v({
  "Actions": "index-module__opassG__Actions",
  "Backdrop": "index-module__opassG__Backdrop",
  "Button": "index-module__opassG__Button",
  "Chip": "index-module__opassG__Chip",
  "ChipRemove": "index-module__opassG__ChipRemove",
  "Chips": "index-module__opassG__Chips",
  "Container": "index-module__opassG__Container",
  "CreateButton": "index-module__opassG__CreateButton",
  "CreateText": "index-module__opassG__CreateText",
  "Description": "index-module__opassG__Description",
  "DialogPopup": "index-module__opassG__DialogPopup",
  "Empty": "index-module__opassG__Empty",
  "Input": "index-module__opassG__Input",
  "InputGroup": "index-module__opassG__InputGroup",
  "Item": "index-module__opassG__Item",
  "ItemIndicator": "index-module__opassG__ItemIndicator",
  "ItemText": "index-module__opassG__ItemText",
  "Label": "index-module__opassG__Label",
  "Popup": "index-module__opassG__Popup",
  "Positioner": "index-module__opassG__Positioner",
  "TextField": "index-module__opassG__TextField",
  "Title": "index-module__opassG__Title",
});
